import { useMutation, useQueryClient } from '@tanstack/react-query';
import restClient from '../common/api/restClient';

export const useDeleteUserGroups = () => {
  const queryClient = useQueryClient();
  const prefix = process.env.REACT_APP_PROXY_PREFIX || '';
  return useMutation({
    mutationFn: async (teamId) => {
      const result = await restClient({
         url: `${prefix}/teams/${teamId}`,
        method: 'delete'
      });
      return result;
    },
    onSuccess: () => {
      // Invalidate and refetch user groups data after successful deletion
      queryClient.invalidateQueries(['userGroupTeams']);
    },
    onError: (error) => {
    }
  });
};
